import { render, staticRenderFns } from "./portalban.vue?vue&type=template&id=54a91718&scoped=true&"
import script from "./portalban.vue?vue&type=script&lang=js&"
export * from "./portalban.vue?vue&type=script&lang=js&"
import style0 from "./portalban.vue?vue&type=style&index=0&id=54a91718&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a91718",
  null
  
)

export default component.exports